import { SparkFormDefinition, SparkFormElement, SparkFormOverlayEntry } from '../types/sparkTypes';

export function buildSparkFormDefinitions(
  overlay?: SparkFormOverlayEntry[] | null,
  elements?: Record<string, SparkFormElement> | null
): Record<string, SparkFormDefinition> | null {
  if (!overlay || !elements) return null;

  const definitions: Record<string, SparkFormDefinition> = {};
  overlay.forEach((spec) => {
    if (!spec?.id || !Array.isArray(spec.groups)) return;

    definitions[spec.id] = {
      label: spec.label ?? null,
      groups: spec.groups.map((group) => ({
        label: group.label,
        description: group.description ?? null,
        elements: (group.elements || []).map((elementId) => elements[elementId]).filter(Boolean) as SparkFormElement[],
      })),
    };
  });

  return definitions;
}

export function formatSparkFormLabel(formId: string, formDefinition?: SparkFormDefinition | null): string {
  const explicitLabel = formDefinition?.label?.trim();
  if (explicitLabel) {
    return explicitLabel;
  }
  return formId.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
}

export function resolveSparkFormLabelFromOverlay(
  formId: string,
  ...overlays: Array<SparkFormOverlayEntry[] | null | undefined>
): string | null {
  for (const overlay of overlays) {
    const explicitLabel = overlay?.find((entry) => entry.id === formId)?.label?.trim();
    if (explicitLabel) {
      return explicitLabel;
    }
  }
  return null;
}
